import { render, staticRenderFns } from "./GenerateTPS.vue?vue&type=template&id=53aa3372&scoped=true"
import script from "./GenerateTPS.vue?vue&type=script&lang=js"
export * from "./GenerateTPS.vue?vue&type=script&lang=js"
import style0 from "./GenerateTPS.vue?vue&type=style&index=0&id=53aa3372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa3372",
  null
  
)

export default component.exports